// import React, { useState, useEffect, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { Search, Filter, Download, Calendar, ArrowUpRight, CreditCard } from 'lucide-react';
// import * as XLSX from 'xlsx';
// import { toast } from 'react-toastify';
// import '../../Dashboard Style/WalletTransaction.css'; // Reusing your existing CSS

// const LevelIncome = ({ title, incomeType }) => {
//   const authToken = useSelector((state) => state.user?.token);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [perPage, setPerPage] = useState(15);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');
//   const [originalTransactions, setOriginalTransactions] = useState([]);
  

//   const toggleSidebar = () => {
//       setSidebarOpen(!sidebarOpen);
//     };
  
//     // Initialize sidebar functionality (same as in Dashboard)
//     useEffect(() => {
//       const sidebar = document.querySelector('.sidebar');
//       const sidebarBody = document.querySelector('.sidebar-body');
      
//       if (sidebar) {
//         if (sidebarOpen) {
//           sidebar.classList.remove('close');
//         } else {
//           sidebar.classList.add('close');
//         }
//       }
      
//       // Add custom scrollbar to sidebar body
//       if (sidebarBody) {
//         sidebarBody.style.height = 'calc(100vh - 70px)';
//         sidebarBody.style.overflowY = 'auto';
//       }
  
//       return () => {
//         // Cleanup
//       };
//     }, [sidebarOpen]);
  
//     useEffect(() => {
//       // Add custom scrollbar styles for sidebar
//       const style = document.createElement('style');
//       style.innerHTML = `
//         /* Custom scrollbar for sidebar */
//         .sidebar-body {
//           height: calc(100vh - 70px);
//           overflow-y: auto;
//         }
        
//         .sidebar-body::-webkit-scrollbar {
//           width: 6px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-track {
//           background: rgba(255, 255, 255, 0.05);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb {
//           background: rgba(255, 255, 255, 0.2);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb:hover {
//           background: rgba(255, 255, 255, 0.3);
//         }
        
//         /* Sidebar dropdown menu styles */
//         .sidebar .nav-dropdown {
//           list-style: none;
//           padding-left: 0;
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//         }
        
//         .sidebar .nav-dropdown.show {
//           max-height: 500px;
//         }
        
//         .sidebar .nav-dropdown-item {
//           padding-left: 2.5rem;
//         }
        
//         /* Sidebar dropdown toggle with icon */
//         .nav-item.has-dropdown .nav-link {
//           position: relative;
//           padding-right: 2.5rem;
//         }
        
//         .nav-item.has-dropdown .dropdown-icon {
//           position: absolute;
//           right: 1rem;
//           top: 50%;
//           transform: translateY(-50%);
//           transition: transform 0.3s ease;
//         }
        
//         .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//           transform: translateY(-50%) rotate(180deg);
//         }
        
//         /* Improved dropdown styling similar to first image */
//         .nav-item.has-dropdown .nav-dropdown {
//           background: rgba(255, 255, 255, 0.05);
//           border-left: 3px solid var(--primary-color, #0d6efd);
//           margin-left: 1rem;
//           border-radius: 0 0 8px 8px;
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//           padding: 0.75rem 1rem 0.75rem 2rem;
//           color: rgba(255, 255, 255, 0.8);
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//           background: rgba(255, 255, 255, 0.1);
//           color: white;
//         }
        
//         /* Fix for category text styling */
//         .nav-item.has-dropdown .link-title.nav-item.nav-category {
//           font-weight: 600;
//           font-size: 0.875rem;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
        
//         /* Smooth transitions */
//         .sidebar {
//           transition: all 0.3s ease;
//         }
//       `;
//       document.head.appendChild(style);
  
//       return () => {
//         document.head.removeChild(style);
//       };
//     }, []);

//   const fetchIncomeData = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`https://global.thewillowquantum.com/api/user/get-wallet-transaction`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: new URLSearchParams({
//           wallet_type: incomeType, // Dynamic based on route
//           per_page: perPage.toString(),
//           page: currentPage.toString()
//         })
//       });

//       const data = await response.json();
//       if (data.status) {
//         setTransactions(data.data || []);
//         setTotalPages(data.pagination?.last_page || 1);
//       } else {
//         toast.error(data.message || `Failed to fetch ${title}`);
//       }
//     } catch (error) {
//       toast.error("Connection Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//     const handleDateFilterChange = (filter) => {
//       setDateFilter(filter);
//       setCurrentPage(1);
//       toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
//     };

//       const handleSearch = (e) => {
//     e.preventDefault();
//     // Search is handled by filteredTransactions memo
//   };

//    const filteredTransactions = useMemo(() => {
//       let filtered = [...originalTransactions];
  
//       // Apply search filter
//       if (searchQuery.trim()) {
//         const query = searchQuery.toLowerCase();
//         filtered = filtered.filter(transaction => 
//           transaction.transaction_id?.toString().toLowerCase().includes(query) ||
//           transaction.from_user_email?.toLowerCase().includes(query) ||
//           transaction.transaction_type?.toLowerCase().includes(query) ||
//           transaction.opening_bal?.toString().includes(query) ||
//           transaction.credit_bal?.toString().includes(query) ||
//           transaction.debit_bal?.toString().includes(query) ||
//           transaction.closing_bal?.toString().includes(query)
//         );
//       }
  
//       // Apply date filter
//       if (dateFilter !== 'all') {
//         const now = new Date();
//         filtered = filtered.filter(transaction => {
//           const transactionDate = new Date(transaction.created_at);
          
//           switch (dateFilter) {
//             case 'today':
//               return transactionDate.toDateString() === now.toDateString();
            
//             case 'week': {
//               const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
//               return transactionDate >= oneWeekAgo;
//             }
            
//             case 'month': {
//               const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
//               return transactionDate >= oneMonthAgo;
//             }
            
//             case 'year': {
//               const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
//               return transactionDate >= oneYearAgo;
//             }
            
//             default:
//               return true;
//           }
//         });
//       }
  
//       return filtered;
//     }, [originalTransactions, searchQuery, dateFilter]);
  

//   useEffect(() => { fetchIncomeData(); }, [currentPage, perPage, incomeType]);

//   const filteredData = useMemo(() => {
//     let filtered = [...transactions];
//     if (searchQuery.trim()) {
//       const q = searchQuery.toLowerCase();
//       filtered = filtered.filter(t => t.transaction_id?.toString().includes(q) || t.from_user_email?.toLowerCase().includes(q));
//     }
//     return filtered;
//   }, [transactions, searchQuery]);

//   const handleDownload = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Report');
//     XLSX.writeFile(wb, `${title}_Report.xlsx`);
//     toast.success("Report Exported");
//   };

//   return (
//       <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar - Update to pass toggleSidebar prop */}
//         <Navbar toggleSidebar={toggleSidebar} />
//         <div className="page-content p-4">
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <h3 className="text-white">{title}</h3>
//           </div>

//          <div className="row mb-4">
//                       <div className="col-md-8">
//                         <div className="d-flex gap-3 search-filter">
//                           <form onSubmit={handleSearch} className="flex-grow-1">
//                             <div className="search-box">
//                               <Search size={18} className="search-icon" />
//                               <input
//                                 type="text"
//                                 className="search-input"
//                                 placeholder="Search by transaction ID, email, or amount..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                               />
//                               {/* <button type="submit" className="search-btn">
//                                 Search
//                               </button> */}
//                             </div>
//                           </form>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               <Filter size={16} className="me-2" />
//                               {dateFilter === 'all' ? 'Filter by Date' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
//                             </button>
//                             <div className="dropdown-menu">
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('today')}
//                               >
//                                 Today
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('week')}
//                               >
//                                 This Week
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('month')}
//                               >
//                                 This Month
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('year')}
//                               >
//                                 This Year
//                               </button>
//                               <div className="dropdown-divider"></div>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('all')}
//                               >
//                                 All Time
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div className="d-flex export-page gap-2">
//                           <button 
//                             className="btn btn-outline-light"
//                             onClick={handleDownload}
//                             disabled={filteredTransactions.length === 0}
//                           >
//                             <Download size={16} className="me-2" />
//                             Export ({filteredTransactions.length})
//                           </button>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               {perPage} per page
//                             </button>
//                             <div className="dropdown-menu">
//                               {[10, 15, 25, 50, 100].map((num) => (
//                                 <button
//                                   key={num}
//                                   className={`dropdown-item ${perPage === num ? 'active' : ''}`}
//                                   onClick={() => {
//                                     setPerPage(num);
//                                     toast.info(`Displaying ${num} transactions per page`);
//                                   }}
//                                 >
//                                   {num} per page
//                                 </button>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//           <div className="transaction-table-wrapper">
//             {loading ? (
//               <div className="text-center py-5"><div className="spinner-border text-light"></div></div>
//             ) : (
//               <div className="table-responsive">
//                 <table className="transaction-table">
//                   <thead>
//                     <tr>
//                       <th>Transaction ID</th>
//                       <th>Type</th>
//                       <th>From/To</th>
//                       <th>Opening</th>
//                       <th>Amount</th>
//                       <th>Closing</th>
//                       <th>Date</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredData.map((t) => (
//                       <tr key={t.id}>
//                         <td>#{t.transaction_id}</td>
//                         <td className="text-info"><CreditCard size={14} className="me-1"/> {t.transaction_type}</td>
//                         <td>{t.from_user_email || 'System'}</td>
//                         <td>${parseFloat(t.opening_bal).toFixed(2)}</td>
//                         <td className={t.credit_bal > 0 ? "text-green" : "text-red"}>
//                             {t.credit_bal > 0 ? `+$${t.credit_bal}` : `-$${t.debit_bal}`}
//                         </td>
//                         <td>${parseFloat(t.closing_bal).toFixed(2)}</td>
//                         <td><Calendar size={14}/> {new Date(t.created_at).toLocaleDateString()}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </div>
//          <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0 text-white">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default LevelIncome;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { Search, Filter, Download, ChevronLeft, ChevronRight, User, DollarSign, Percent, Clock } from 'lucide-react';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import '../../Dashboard Style/WalletTransaction.css';
import { getDirectLevelIncomeListApi } from '../../Services/Operations/ProductAPI'; // Import the new API

const LevelIncome = ({ title, incomeType }) => {
  const authToken = useSelector((state) => state.user?.token);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalCommission, setTotalCommission] = useState(0);

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };

  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);
  
  useEffect(() => {
    // Add custom styles for Level Income page
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Level Income specific styles */
      .level-badge {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
        display: inline-block;
      }
      
      .user-details {
        background: rgba(255, 255, 255, 0.03);
        border-radius: 8px;
        padding: 8px;
        border-left: 3px solid #0d6efd;
      }
      
      .position-badge {
        background: rgba(0, 164, 120, 0.2);
        color: #00a478;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 500;
      }
      
      .amount-value {
        font-weight: 700;
        color: #00a478;
      }
      
      .commission-percentage {
        font-weight: 600;
        color: #0dcaf0;
      }
      
      .commission-amount {
        font-weight: 700;
        color: #ff6b6b;
      }
      
      /* Table styles matching the design */
      .level-income-table {
        background: rgba(255, 255, 255, 0.02);
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      .level-income-table thead th {
        background: linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%);
        color: #e9ecef;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 0.5px;
        padding: 15px 12px;
        border-bottom: 2px solid rgba(13, 110, 253, 0.3);
      }
      
      .level-income-table tbody td {
        padding: 15px 12px;
        vertical-align: middle;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        color: #e9ecef;
      }
      
      .level-income-table tbody tr:hover {
        background: rgba(255, 255, 255, 0.03);
      }
      
      /* Pagination styles */
      .pagination-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
      }
      
      .pagination-info {
        color: #adb5bd;
        font-size: 14px;
      }
      
      .pagination-buttons .btn {
        margin: 0 5px;
        min-width: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      
      .page-numbers {
        display: flex;
        gap: 5px;
      }
      
      .page-numbers .btn {
        min-width: 35px;
      }
      
      /* Summary cards */
      .summary-card {
        background: linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%);
        border-radius: 10px;
        padding: 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: transform 0.3s ease;
      }
      
      .summary-card:hover {
        transform: translateY(-5px);
      }
      
      .summary-card.income-card {
        border-left: 4px solid #00a478;
      }
      
      .summary-card.commission-card {
        border-left: 4px solid #ff6b6b;
      }
      
      .summary-card.transactions-card {
        border-left: 4px solid #0dcaf0;
      }
      
      /* Search box styles */
      .search-box-level {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        padding: 8px 15px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
      }
      
      .search-box-level input {
        background: transparent;
        border: none;
        color: white;
        flex: 1;
        padding: 0 10px;
        outline: none;
      }
      
      .search-box-level input::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
    `;
    document.head.appendChild(style);
    
    // Fetch data on component mount
    fetchDirectLevelIncome();

    return () => {
      document.head.removeChild(style);
    };
  }, [currentPage, perPage]);

    useEffect(() => {
        const sidebar = document.querySelector('.sidebar');
        const sidebarBody = document.querySelector('.sidebar-body');
        
        if (sidebar) {
          if (sidebarOpen) {
            sidebar.classList.remove('close');
          } else {
            sidebar.classList.add('close');
          }
        }
        
        if (sidebarBody) {
          sidebarBody.style.height = 'calc(100vh - 70px)';
          sidebarBody.style.overflowY = 'auto';
        }
    
        return () => {};
      }, [sidebarOpen]);
    
      useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
          .sidebar-body {
            height: calc(100vh - 70px);
            overflow-y: auto;
          }
          
          .sidebar-body::-webkit-scrollbar {
            width: 6px;
          }
          
          .sidebar-body::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 10px;
          }
          
          .sidebar-body::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 10px;
          }
          
          .sidebar-body::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 0.3);
          }
          
          .sidebar .nav-dropdown {
            list-style: none;
            padding-left: 0;
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease;
          }
          
          .sidebar .nav-dropdown.show {
            max-height: 500px;
          }
          
          .sidebar .nav-dropdown-item {
            padding-left: 2.5rem;
          }
          
          .nav-item.has-dropdown .nav-link {
            position: relative;
            padding-right: 2.5rem;
          }
          
          .nav-item.has-dropdown .dropdown-icon {
            position: absolute;
            right: 1rem;
            top: 50%;
            transform: translateY(-50%);
            transition: transform 0.3s ease;
          }
          
          .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
            transform: translateY(-50%) rotate(180deg);
          }
          
          .nav-item.has-dropdown .nav-dropdown {
            background: rgba(255, 255, 255, 0.05);
            border-left: 3px solid var(--primary-color, #0d6efd);
            margin-left: 1rem;
            border-radius: 0 0 8px 8px;
          }
          
          .nav-item.has-dropdown .nav-dropdown-item .nav-link {
            padding: 0.75rem 1rem 0.75rem 2rem;
            color: rgba(255, 255, 255, 0.8);
          }
          
          .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
            background: rgba(255, 255, 255, 0.1);
            color: white;
          }
          
          .nav-item.has-dropdown .link-title.nav-item.nav-category {
            font-weight: 600;
            font-size: 0.875rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          
          .sidebar {
            transition: all 0.3s ease;
          }
        `;
        document.head.appendChild(style);
    
        return () => {
          document.head.removeChild(style);
        };
      }, []);
    
  
  const fetchDirectLevelIncome = async () => {
    try {
      setLoading(true);
      const result = await getDirectLevelIncomeListApi(authToken, currentPage, perPage);
      
      if (result.status) {
        setTransactions(result.data);
        setTotalPages(result.pagination.last_page || 1);
        
        // Calculate totals
        const incomeTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.amount_value) || 0), 0);
        const commissionTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.commission_amount) || 0), 0);
        
        setTotalIncome(incomeTotal);
        setTotalCommission(commissionTotal);
        
      } else {
        toast.error(result.message || 'Failed to load direct level income');
      }
    } catch (error) {
      console.error('Error fetching direct level income:', error);
      toast.error('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleSearch = (e) => {
    e.preventDefault();
    // Search is handled by filteredTransactions memo
  };
  
  const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    setCurrentPage(1);
    toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
  };
  
  const filteredTransactions = useMemo(() => {
    let filtered = [...transactions];
    
    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(transaction => 
        transaction.from_user_email?.toLowerCase().includes(query) ||
        transaction.from_user_account_name?.toLowerCase().includes(query) ||
        transaction.direct_level?.toLowerCase().includes(query) ||
        transaction.amount_value?.toString().includes(query) ||
        transaction.commission_amount?.toString().includes(query)
      );
    }
    
    // Apply date filter
    if (dateFilter !== 'all') {
      const now = new Date();
      filtered = filtered.filter(transaction => {
        const transactionDate = new Date(transaction.created_at);
        
        switch (dateFilter) {
          case 'today':
            return transactionDate.toDateString() === now.toDateString();
          case 'week': {
            const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            return transactionDate >= oneWeekAgo;
          }
          case 'month': {
            const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
            return transactionDate >= oneMonthAgo;
          }
          case 'year': {
            const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
            return transactionDate >= oneYearAgo;
          }
          default:
            return true;
        }
      });
    }
    
    return filtered;
  }, [transactions, searchQuery, dateFilter]);
  
const handleDownload = () => {
  if (filteredTransactions.length === 0) {
    toast.warning('No data to export');
    return;
  }
  
  const exportData = filteredTransactions.map((item, index) => ({
    'SL No': index + 1,
    'Direct Level': item.direct_level,
    'User Email': item.from_user_email,
    'Account Name': item.from_user_account_name,
    'Amount Value': `$${item.amount_value}`,
    'Commission %': `${item.commission_percentage}%`,
    'Commission Amount': `$${item.commission_amount}`,
    'Status': item.status, // Add status
    'Description': item.description, // Add description
    'Created At': item.created_at
  }));
  
  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Direct Level Income');
  XLSX.writeFile(wb, `Direct_Level_Income_${new Date().toISOString().split('T')[0]}.xlsx`);
  toast.success('Report exported successfully!');
};
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };
  
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  
  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  // Get position indicator (assuming you have position data)
  const getPositionIndicator = (userId) => {
    // You'll need to get actual position data from your API
    // For now, using a mock based on user ID
    const positions = ['L', 'R'];
    return positions[userId % 2];
  };

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
                          isOpen={!sidebarOpen}
                          onClose={closeSidebar}
                        />
              
                        {/* Mobile backdrop */}
                        {isMobile && sidebarOpen && (
                          <div
                            className="sidebar-backdrop"
                            onClick={closeSidebar}
                          />
                        )}
             </nav>
       
             <div className="page-wrapper">
               <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
                   isMobile={isMobile}/>
       
        
        <div className="page-content p-4">
          {/* Page Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="text-white fw-bold mb-1">{title}</h3>
              <p className="text-muted mb-0">Track your direct level income and commissions</p>
            </div>
            <div>
              <span className="badge bg-primary">Level 1-10</span>
            </div>
          </div>
          
          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-4">
              <div className="summary-card income-card">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <DollarSign size={24} className="text-success" />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Income Value</h6>
                    <h3 className="text-white mb-0">${totalIncome.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="summary-card commission-card">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <Percent size={24} className="text-danger" />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Commission</h6>
                    <h3 className="text-white mb-0">${totalCommission.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="summary-card transactions-card">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <User size={24} className="text-info" />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Transactions</h6>
                    <h3 className="text-white mb-0">{filteredTransactions.length}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Search and Filter Section */}
          <div className="row mb-4">
            <div className="col-md-8">
              <div className="d-flex gap-3">
                <form onSubmit={handleSearch} className="flex-grow-1">
                  <div className="search-box-level">
                    <Search size={18} className="text-muted me-2" />
                    <input
                      type="text"
                      placeholder="Search by email, account name, or level..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </form>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Filter size={16} className="me-2" />
                    {dateFilter === 'all' ? 'All Time' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
                  </button>
                  <div className="dropdown-menu">
                    <button 
                      className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('today')}
                    >
                      Today
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('week')}
                    >
                      This Week
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('month')}
                    >
                      This Month
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('year')}
                    >
                      This Year
                    </button>
                    <div className="dropdown-divider"></div>
                    <button 
                      className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('all')}
                    >
                      All Time
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-end gap-2">
                <button 
                  className="btn btn-outline-light"
                  onClick={handleDownload}
                  disabled={filteredTransactions.length === 0}
                >
                  <Download size={16} className="me-2" />
                  Export ({filteredTransactions.length})
                </button>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    {perPage} per page
                  </button>
                  <div className="dropdown-menu">
                    {[10, 15, 25, 50, 100].map((num) => (
                      <button
                        key={num}
                        className={`dropdown-item ${perPage === num ? 'active' : ''}`}
                        onClick={() => {
                          setPerPage(num);
                          setCurrentPage(1);
                          toast.info(`Displaying ${num} records per page`);
                        }}
                      >
                        {num} per page
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Table Section */}
          <div className="level-income-table">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-white">Loading direct level income data...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                 <thead>
  <tr>
    <th>SL No.</th>
    <th>Direct Level (L)</th>
    <th>User Details</th>
    <th>Amount Value</th>
    <th>My Commission (%)</th>
    <th>My Commission ($)</th>
    <th>Status</th>
    <th>Description</th>
    <th>Timestamp</th>
  </tr>
</thead>
<tbody>
  {filteredTransactions.length === 0 ? (
    <tr>
      <td colSpan="9" className="text-center py-5">
        <div className="text-muted">
          <User size={48} className="mb-3 opacity-50" />
          <h5 className="text-white">No direct level income found</h5>
          <p className="text-muted mb-0">Start referring users to see your direct level income</p>
        </div>
      </td>
    </tr>
  ) : (
    filteredTransactions.map((transaction, index) => (
      <tr key={transaction.id} className="border-bottom border-dark">
        {/* SL. NO. */}
        <td className="align-middle">
          <div className="d-flex align-items-center">
            <div className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                 style={{ width: '28px', height: '28px', fontSize: '12px', fontWeight: '600' }}>
              {(currentPage - 1) * perPage + index + 1}
            </div>
          </div>
        </td>
        
        {/* DIRECT LEVEL (L) */}
        <td className="align-middle">
          <span className="badge bg-gradient-primary text-white px-3 py-2 rounded-pill fw-semibold">
            {transaction.direct_level}
          </span>
        </td>
        
        {/* USER DETAILS */}
        <td className="align-middle">
          <div className="bg-dark border-start border-primary border-3 p-3 rounded-end">
            <div className="d-flex align-items-center mb-2">
              <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2" 
                   style={{ width: '32px', height: '32px' }}>
                <User size={16} className="text-primary" />
              </div>
              <div>
                <div className="text-white fw-semibold">{transaction.from_user_account_name}</div>
                <div className="small">{transaction.user_code}</div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <span className="badge bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded" style={{color:"black"}}>
                Position: {getPositionIndicator(transaction.id)}
              </span>
            </div>
          </div>
        </td>
        
        {/* AMOUNT VALUE */}
        <td className="align-middle">
          <div className="d-flex align-items-center">
            <div>
              <div className="text-white fw-bold fs-5">${parseFloat(transaction.amount_value || 0).toFixed(2)}</div>
            </div>
          </div>
        </td>
        
        {/* MY COMMISSION (%) */}
        <td className="align-middle">
          <div className="bg-info bg-opacity-10 p-2 rounded text-center">
            <div className="text-info fw-bold fs-5">{transaction.commission_percentage}%</div>
          </div>
        </td>
        
        {/* MY COMMISSION ($) */}
        <td className="align-middle">
          <div className="bg-warning bg-opacity-10 p-2 rounded text-center">
            <div className=" fw-bold fs-5">${parseFloat(transaction.commission_amount || 0).toFixed(2)}</div>
          </div>
        </td>
        
        {/* STATUS */}
        <td className="align-middle">
          <div className={`${transaction.status === 'CREDITED' ? 'bg-success' : 'bg-danger'} bg-opacity-10 p-2 rounded text-center`}>
            <div className={`${transaction.status === 'CREDITED' ? '' : 'text-danger'} fw-bold`}>
              {transaction.status}
            </div>
          </div>
        </td>
        
        {/* DESCRIPTION */}
        <td className="align-middle">
          <div className="bg-dark bg-opacity-10 p-2 rounded">
            <div className="text-white small">{transaction.description}</div>
          </div>
        </td>
        
        {/* TIMESTAMP */}
        <td className="align-middle">
          <div className="bg-dark p-2 rounded">
            <div className="small">{formatDate(transaction.created_at)}</div>
          </div>
        </td>
      </tr>
    ))
  )}
</tbody>
                </table>
              </div>
            )}
          </div>
          
          {/* Pagination */}
          {!loading && filteredTransactions.length > 0 && (
            <div className="pagination-container mt-4">
              <div className="pagination-info">
                Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, filteredTransactions.length)} of {filteredTransactions.length} entries
              </div>
              <div className="pagination-buttons">
                <button
                  className="btn btn-outline-light btn-sm"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={16} /> Prev
                </button>
                
                <div className="page-numbers d-inline-block mx-2">
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }
                    
                    return (
                      <button
                        key={pageNum}
                        className={`btn btn-sm ${currentPage === pageNum ? 'btn-primary' : 'btn-outline-light'}`}
                        onClick={() => handlePageClick(pageNum)}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                  
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <>
                      <span className="mx-2 text-muted">...</span>
                      <button
                        className="btn btn-outline-light btn-sm"
                        onClick={() => handlePageClick(totalPages)}
                      >
                        {totalPages}
                      </button>
                    </>
                  )}
                </div>
                
                <button
                  className="btn btn-outline-light btn-sm"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            </div>
          )}
        </div>
        
        {/* Footer */}
        <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
          <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default LevelIncome;